import { flatten } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AngularFireStorage, AngularFireStorageReference } from '@angular/fire/compat/storage';
import { serverTimestamp, deleteField, runTransaction, getFirestore } from 'firebase/firestore';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { IEmpresa } from 'src/app/shared/components/dialog/models/empresa.model';
import { EncuestaEncabezado } from 'src/app/shared/components/dialog/models/encuesta-encabezado';
import { EncuestaFinal } from 'src/app/shared/components/dialog/models/encuesta-final';
import { CabeceraRespuesta } from 'src/app/shared/components/formularios-encuesta/models/cabecera-respuesta';
import { IImageUploaded } from 'src/app/shared/components/upload/IImageUploaded';
import { UploadService } from 'src/app/shared/components/upload/upload.service';
import { colections, documentsEmpresa, documentEncuesta } from 'src/app/shared/cons/db.colections';
import { Utils } from 'src/app/shared/helpers/utils';
import { TransaccionModel } from 'src/app/shared/services/models/trasaccion.model';
import { RegistroService } from 'src/app/shared/services/registro.service';
@Injectable({
  providedIn: 'root'
})
export class GestionFormularioDaService {
  transaccion: TransaccionModel = new TransaccionModel();
    private formulariosCache: BehaviorSubject<EncuestaFinal[] | null | undefined> = new BehaviorSubject<EncuestaFinal[] | null | undefined>(undefined);
    public formularios$: Observable<EncuestaFinal[] | null | undefined> = this.formulariosCache.asObservable();
    private fetchFormulariosSubscription!: Subscription;
    
  constructor(
      private db: AngularFirestore,
      private uploadService: UploadService,
      private registroService: RegistroService,
      private storage : AngularFireStorage,
  ) { }

  private removeUtilPropertiesEncabezado(formulario:EncuestaFinal): EncuestaFinal {
    delete formulario.encabezado.path_fondo_editar;
    delete formulario.encabezado.path_logo_editar;
    return formulario;
  }

  private removeUtilProperties(formulario:EncuestaFinal): EncuestaFinal {
    delete formulario.id;
    delete formulario.id_ref;
    delete formulario.es_guardado;
    delete formulario.idEmpresa;
    delete formulario.ruta_completa;
    return formulario;
  }
  
  fetchFormularioByIdEmpresa(idEmpresa: string): void {
    if (
      this.fetchFormulariosSubscription &&
      !this.fetchFormulariosSubscription.closed
    ) {
      this.formulariosCache.next(this.formulariosCache.value);
      return;
    }
    
    this.fetchFormulariosSubscription = this.getFormularioSnapshot(idEmpresa).subscribe((formularios: EncuestaFinal[] | null) => {
      this.formulariosCache.next(formularios);
    });
  }

  stopFetchingFormularios(): void {
    if (this.fetchFormulariosSubscription) {
      this.fetchFormulariosSubscription.unsubscribe();
    }
    this.formulariosCache.next(undefined);
  }

  getFormularioSnapshot(idEmpresa:string){
    let listaFormularios: EncuestaFinal[] =[];

    const query = this.db.collection(colections.EMPRESA, ref=>
      ref.where(documentsEmpresa.ES_BORRADO,'==',false).
      where(documentsEmpresa.ES_VIGENTE,'==',true))
      .doc(idEmpresa).collection(colections.ENCUESTA, ref1=>
        ref1.where(documentEncuesta.ES_BORRADO,'==',false)
        .orderBy(documentEncuesta.FECHA_CREACION,'desc')
      )
    
    return query.snapshotChanges().pipe(map((formularios)=>{
      listaFormularios=[];
      if(formularios.length>0){
        formularios.forEach(formu=>{
          const formularioConvertido = formu.payload.doc.data() as EncuestaFinal;
          formularioConvertido.id = formu.payload.doc.id;         
          formularioConvertido.es_guardado = true;

          listaFormularios.push(formularioConvertido);
        });
        return listaFormularios;
      }else{
        return null;
      }
    }))
  }

  async insertFormulario(
    formulario: EncuestaFinal,
    files_upload: File[],
    pathFileAPI: string,
    idEmpresa: string,
    
  ) {
    //quitando el id
    formulario = { ...this.removeUtilProperties(formulario) };
    const empresaRef =  this.db.collection(colections.EMPRESA).doc(idEmpresa);
    const formularioRef =  empresaRef.collection(colections.ENCUESTA);
    try {
      const transactionResult = await this.db.firestore.runTransaction(async (transaction) => {
        //si no contiene imagen
        if (files_upload.length == 0) {
          const docFormulario = Utils.SerializeJsonToDb(formulario);
          docFormulario.fecha_creacion = serverTimestamp();          
          transaction.set(formularioRef.doc().ref, docFormulario);
          this.transaccion.tx = true;
          this.transaccion.data = formularioRef.ref.id;
          return this.transaccion;
        }
        //si tiene archivos para subir TODO: escritura bucle
        else {
          return this.uploadService
            .onSaveFiles(files_upload, pathFileAPI).then((urls) => {
              const resultsURls =Utils.ObjecToListToArray(urls);
              let insertLogo:boolean = false;
              let insertFondo:boolean = false;
              let nImagenLogo!:any;
              let nImagenFondo!:any;
              if (formulario.encabezado.path_logo && formulario.encabezado.path_fondo) {
                insertLogo = true;
                insertFondo = true;
                nImagenLogo = resultsURls[0];
                nImagenFondo  = resultsURls[1];
              }else{
                if (formulario.encabezado.path_logo) {
                  insertLogo = true;
                  nImagenLogo = resultsURls[0];                      
                }
                if (formulario.encabezado.path_fondo) {
                  insertFondo = true;
                  nImagenFondo = resultsURls[0];
                } 
              }                  

              if(insertLogo)formulario.encabezado.path_logo =  nImagenLogo;
              if(insertFondo)formulario.encabezado.path_fondo =  nImagenFondo;
                          
              const docFormulario = Utils.SerializeJsonToDb(formulario);
              docFormulario.fecha_creacion = serverTimestamp();
              docFormulario.es_publicado = false;
              transaction.set(formularioRef.doc().ref, docFormulario);
              this.transaccion.tx = true;
              this.transaccion.data = formularioRef.ref.id;
              return this.transaccion;
            });
        }
      });
      return transactionResult;
    }
    catch (error) {
      this.transaccion.tx = false;
      this.transaccion.data = error;
      return this.transaccion;
    }


  }

  
  async publishFormulario(formulario: EncuestaFinal, idEmpresa:string):Promise<TransaccionModel>{
    const idFormulario = formulario.id;
    const docEncuestaRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref=>ref.where(documentEncuesta.ID_REF,'==',idFormulario)).get();
    const empresaRef =  this.db.collection(colections.EMPRESA).doc(idEmpresa);
    const formularioRef =  empresaRef.collection(colections.ENCUESTA).doc(idFormulario);
    //recuperamos contenido para eliminar
    let formularioFinal: EncuestaFinal = new EncuestaFinal();
    let esInsertar:boolean = false;
    const encuestaForm = await docEncuestaRef.toPromise();
   
    if(!encuestaForm.empty){
      formularioFinal = (encuestaForm.docs[0].data()) as EncuestaFinal;      
      formularioFinal.id = encuestaForm.docs[0].id;
    }
    else{
      esInsertar = true;
    }
        
    try{
      const formularioIns =   Utils.SerializeJsonToDb(formulario);
      formularioIns.idEmpresa =  idEmpresa;
      delete formularioIns.fecha_modificacion;
      delete formularioIns.id;
      delete formularioIns.ruta_completa;

      formularioIns.es_publicado = true;
      const idRef =  formulario.id;          
      formularioIns.id_ref =  idRef;

      const transactionResult = await this.db.firestore.runTransaction(async (transaction) => {
        if(esInsertar){
          //cuando no existe la encuesta
          const refEncuesta = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc();
          formularioIns.fecha_creacion = serverTimestamp();        
          transaction.set(refEncuesta.ref,formularioIns);          
        }
        else{
          //cuando ya existe la cabecera          
          const refEncuesta = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(formularioFinal.id);
          formularioIns.fecha_modificacion = serverTimestamp();
          transaction.update(refEncuesta.ref,{
            'encabezado': formularioIns.encabezado,
            'es_borrado': formularioIns.es_borrado,
            'es_guardado': formularioIns.es_guardado,
            'es_publicado': formularioIns.es_publicado,
            'fecha_modificacion':serverTimestamp(),
            'idEmpresa': formularioIns.idEmpresa,
            'id_ref': formularioIns.id_ref,
            'tipo_pregunta': formularioIns.tipo_pregunta,
            'usuario_modificacion': formularioIns.usuario_creacion // viene por contrabando
          });
          //eliminando las respuestas anteriores por ser una nueva version de la encuesta
          const  respuestaEncuesta = await this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(formularioFinal.id).collection(colections.RESPUESTA_FORMULARIO).get().toPromise();
          const respuestaRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(formularioFinal.id).collection(colections.RESPUESTA_FORMULARIO);
          if(!respuestaEncuesta.empty){
            respuestaEncuesta.docs.forEach(docu =>{
              const idDoc = docu.id
              transaction.delete(respuestaRef.doc(idDoc).ref);
            });
          }
        }
        //actualizando el formulario principal
        transaction.update(formularioRef.ref, {
          'es_publicado':true,
          'fecha_modificacion':serverTimestamp(),
          'usuario_modificacion':formulario.usuario_creacion,
          'ruta_parcial':formulario.ruta_parcial
        });       

        this.transaccion.tx = true;  
        return this.transaccion;  

      });
      return transactionResult;
    }
    catch(error){
      this.transaccion.tx = false;
      this.transaccion.data = error;
      return this.transaccion;
    }

  }

  async noPublishFormulario(formulario: EncuestaFinal, idEmpresa:string):Promise<TransaccionModel>{
    const idFormulario = formulario.id;
    const docEncuestaRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref=>ref.where(documentEncuesta.ID_REF,'==',idFormulario)).get();   
    const encuestaForm = await docEncuestaRef.toPromise();
    const empresaRef =  this.db.collection(colections.EMPRESA).doc(idEmpresa);
    const formularioRef =  empresaRef.collection(colections.ENCUESTA).doc(idFormulario);
   
    try{
      const formularioIns =   Utils.SerializeJsonToDb(formulario);
      formularioIns.idEmpresa =  idEmpresa;
      delete formularioIns.fecha_modificacion;
      delete formularioIns.id; 
      const transactionResult = await this.db.firestore.runTransaction(async (transaction) => {
        const refEncuesta = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(encuestaForm.docs[0].id);        
        transaction.update(refEncuesta.ref,{          
          'es_publicado': false,
          'fecha_modificacion':serverTimestamp(),          
          'usuario_modificacion': formularioIns.usuario_creacion // viene por contrabando
        });
        //actualizando el formulario principal
        transaction.update(formularioRef.ref, {
          'es_publicado':false,
          'fecha_modificacion':serverTimestamp(),
          'usuario_modificacion':formulario.usuario_creacion      
        });      
        this.transaccion.tx = true;  
        return this.transaccion;  
      });
      return transactionResult;
    }
    catch(error){
      this.transaccion.tx = false;
      this.transaccion.data = error;
      return this.transaccion;
    }

  }

  async DeleteFormulario(formulario: EncuestaFinal, idEmpresa: string, pathFileAPI: string): Promise<TransaccionModel> {
    const idFormulario = formulario.id;
    const empresaRef = this.db.collection(colections.EMPRESA).doc(idEmpresa);
    const formularioRef = empresaRef.collection(colections.ENCUESTA).doc(idFormulario);
  
    try {
      // Buscar documento en la colección externa con ID_REF igual a idFormulario
      const querySnapshot = await this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref =>
        ref.where(documentEncuesta.ID_REF, '==', idFormulario)
      ).get().toPromise();
      let idFormularioPublicado:string | null=null;
      let snapshotRespuestas:any;
      // Asegurarse que sí existe el documento
      let docEncuestaRef:any =null;
      if (!querySnapshot.empty) {
        docEncuestaRef = querySnapshot.docs[0].ref;
        idFormularioPublicado = querySnapshot.docs[0].id;
        const rutaFormularioRespuestaExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado).collection(colections.RESPUESTA_FORMULARIO)
        snapshotRespuestas = await rutaFormularioRespuestaExterno.get().toPromise();
      }
  
      
  
      const transactionResult = await this.db.firestore.runTransaction(async (transaction) => {
        let eliminarLogo = false;
        let eliminarFondo = false;
        const imagenesEliminar: IImageUploaded[] = [];
  
        if (formulario.encabezado.path_logo) {
          imagenesEliminar.push(formulario.encabezado.path_logo as IImageUploaded);
          eliminarLogo = true;
        }
  
        if (formulario.encabezado.path_fondo) {
          imagenesEliminar.push(formulario.encabezado.path_fondo as IImageUploaded);
          eliminarFondo = true;
        }
  
        if (eliminarFondo || eliminarLogo) {
          const listaReferencias = imagenesEliminar.map(archivo =>
            this.storage.ref(pathFileAPI + archivo.nombre_plataforma)
          );
          await Promise.all(listaReferencias.map(ref => ref.delete()));
        }
  
        // Eliminar formulario principal y documento externo
        transaction.delete(formularioRef.ref);
        //si es que el documento existe y esta publicado
        if(docEncuestaRef!=null){
          transaction.delete(docEncuestaRef);
          //eliminando subcolecciones
          if(!snapshotRespuestas.empty){
            snapshotRespuestas.forEach((resp:any) => {
              transaction.delete(resp.ref);
            });
          }
        }
        
  
        this.transaccion.tx = true;
        return this.transaccion;
      });
  
      return transactionResult;
    } catch (error) {
      this.transaccion.tx = false;
      this.transaccion.data = error;
      return this.transaccion;
    }
  }

  async UpdateFormulario
  ( formulario: EncuestaFinal, files_upload: File[], pathFileAPI: string,  idEmpresa: string,  cabeceraTemporal:EncuestaFinal, usuario:string, esEditarPregunta:boolean ):Promise<TransaccionModel>
  {
      //quitando el id
      const idFormulario = formulario.id;
      formulario = { ...this.removeUtilProperties(formulario) };
      const empresaRef =  this.db.collection(colections.EMPRESA).doc(idEmpresa);
      const formularioRef =  empresaRef.collection(colections.ENCUESTA).doc(idFormulario);
      
      try {
          const transactionResult = await this.db.firestore.runTransaction(async (transaction) => {
            let eliminarLogo: boolean = false;
            let eliminarFondo: boolean = false;
            const imagenesEliminar: IImageUploaded[] = [];

            this.transaccion.tx = false;
              // Si no contiene imagen nueva subida
              if (files_upload.length == 0) {

                //ELIMINANDO ENCUESTA PUBLICADA Y SUS DATOS SIEMPRE EN CUANDO SE HAYA MODIFICADO ALGUNA PREGUNTA Y LA ENCUESTA HAYA SIDO PUBLICADA
                const docEncuestaRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref => ref.where(documentEncuesta.ID_REF, '==', idFormulario)).get();
                const encuestaForm = await docEncuestaRef.toPromise();
                let idFormularioPublicado: string | null = null;
                if (esEditarPregunta) {
                  if (!encuestaForm.empty) {
                    idFormularioPublicado = encuestaForm.docs[0].id;
                  }
                  if (idFormularioPublicado != null) {
                    const rutaFormularioExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado);
                    const rutaFormularioRespuestaExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado).collection(colections.RESPUESTA_FORMULARIO)
                    const snapshotRespuestas = await rutaFormularioRespuestaExterno.get().toPromise();
                    //borrando subcolecciones
                    if(!snapshotRespuestas.empty){
                      snapshotRespuestas.forEach(resp => {
                        transaction.delete(resp.ref);
                      });
                    }
                    //borrando coleccion principal
                    transaction.delete(rutaFormularioExterno.ref);
                  }
                }else{//despublicando encuesta ya que se modifico solo cabecera
                  if (!encuestaForm.empty) {
                    idFormularioPublicado = encuestaForm.docs[0].id;
                    const rutaFormularioExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado);
                    transaction.update(rutaFormularioExterno.ref,{
                      'es_publicado':false
                    });
                  }
                }


                if (cabeceraTemporal && cabeceraTemporal.encabezado.path_logo_editar) {
                  imagenesEliminar.push(formulario.encabezado.path_logo as IImageUploaded);
                  eliminarLogo = true;
                }
                
                if (cabeceraTemporal &&  cabeceraTemporal.encabezado.path_fondo_editar) {
                  imagenesEliminar.push(formulario.encabezado.path_fondo as IImageUploaded);
                  eliminarFondo = true;
                }
                
                if(eliminarFondo || eliminarLogo){
                  let listaReferencias: AngularFireStorageReference[] = [];
                  imagenesEliminar.forEach(archivo => {
                    listaReferencias.push(this.storage.ref(pathFileAPI + archivo.nombre_plataforma));
                  });
                  await Promise.all(listaReferencias.map(ref => ref.delete()));

                  transaction.update(formularioRef.ref, {
                    'encabezado.titulo': cabeceraTemporal.encabezado.titulo,
                    'encabezado.es_vigente': cabeceraTemporal.encabezado.es_vigente,
                    'encabezado.horario_disponible':  Utils.SerializeJsonToDb(cabeceraTemporal.encabezado.horario_disponible),
                    'tipo_pregunta': Utils.SerializeJsonToDb(formulario.tipo_pregunta),
                    'fecha_modificacion': serverTimestamp(),
                    'es_publicado':false,
                    'usuario_modificacion': usuario,
                    ...(eliminarLogo && { 'encabezado.path_logo': deleteField() }),
                    ...(eliminarFondo && { 'encabezado.path_fondo': deleteField() })
                  });
                  this.transaccion.tx = true;
                  this.transaccion.data = formularioRef.ref.id;
                  return this.transaccion;  

                }else{
                  transaction.update(formularioRef.ref, {
                    'encabezado.titulo': cabeceraTemporal.encabezado.titulo,
                    'encabezado.es_vigente': cabeceraTemporal.encabezado.es_vigente,
                    'tipo_pregunta': Utils.SerializeJsonToDb(formulario.tipo_pregunta),
                    'encabezado.horario_disponible':  Utils.SerializeJsonToDb(cabeceraTemporal.encabezado.horario_disponible),
                    'fecha_modificacion': serverTimestamp(),
                    'es_publicado':false,
                    'usuario_modificacion': usuario,     
                  });
                  this.transaccion.tx = true;
                  this.transaccion.data = formularioRef.ref.id;
                  return this.transaccion;
                }                      
              }  
              // Si tiene archivos para subir, actualizar
              if (files_upload.length > 0) {               
         
                  // Validando qué imágenes se van a eliminar
                  if (cabeceraTemporal.encabezado.path_logo_editar) {                      
                      if (formulario.encabezado.path_logo) {
                        eliminarLogo = true;
                        imagenesEliminar.push(formulario.encabezado.path_logo as IImageUploaded);
                      }
                  }
                  if (cabeceraTemporal.encabezado.path_fondo_editar) {                      
                      if (formulario.encabezado.path_fondo) {
                        eliminarFondo = true;
                        imagenesEliminar.push(formulario.encabezado.path_fondo as IImageUploaded);
                      }
                  }
                  //genenrando lista a eliminar  DOCUMENTO ANTERIOR
                  let listaReferencias: AngularFireStorageReference[] = [];
                  imagenesEliminar.forEach(archivo => {
                    listaReferencias.push(this.storage.ref(pathFileAPI + archivo.nombre_plataforma));
                  });

                  //ELIMINANDO DOCUMENTO
                  if(listaReferencias.length>0){
                    await Promise.all(listaReferencias.map(ref => ref.delete()));
                    //ELMINANDO DEL DOCUMENTO
                    transaction.update(formularioRef.ref, {
                      'encabezado.titulo': cabeceraTemporal.encabezado.titulo,
                      'encabezado.es_vigente': cabeceraTemporal.encabezado.es_vigente,
                      'encabezado.horario_disponible':  Utils.SerializeJsonToDb(cabeceraTemporal.encabezado.horario_disponible),
                      'tipo_pregunta': Utils.SerializeJsonToDb(formulario.tipo_pregunta),
                      'fecha_modificacion': serverTimestamp(),
                      'es_publicado':false,
                      'usuario_modificacion': usuario,
                      ...(eliminarLogo && { 'encabezado.path_logo': deleteField() }),
                      ...(eliminarFondo && { 'encabezado.path_fondo': deleteField() })
                    });
                  }else{
                     //actualizando solamente el titulo
                     transaction.update(formularioRef.ref, {
                      'encabezado.titulo': cabeceraTemporal.encabezado.titulo,                      
                      'encabezado.es_vigente': cabeceraTemporal.encabezado.es_vigente,
                      'encabezado.horario_disponible':  Utils.SerializeJsonToDb(cabeceraTemporal.encabezado.horario_disponible),
                      'tipo_pregunta': Utils.SerializeJsonToDb(formulario.tipo_pregunta),
                      'fecha_modificacion': serverTimestamp(),
                      'es_publicado':false,
                      'usuario_modificacion': usuario,                   
                    });
                  }
                  
                  //ELIMINANDO ENCUESTA PUBLICADA Y SUS DATOS SIEMPRE EN CUANDO SE HAYA MODIFICADO ALGUNA PREGUNTA Y LA ENCUESTA HAYA SIDO PUBLICADA
                  const docEncuestaRef = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, ref => ref.where(documentEncuesta.ID_REF, '==', idFormulario)).get();
                  const encuestaForm = await docEncuestaRef.toPromise();
                  let idFormularioPublicado: string | null = null;
                  if (esEditarPregunta) {
                    if (!encuestaForm.empty) {
                      idFormularioPublicado = encuestaForm.docs[0].id;
                    }
                    if (idFormularioPublicado != null) {
                      const rutaFormularioExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado);
                      const rutaFormularioRespuestaExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado).collection(colections.RESPUESTA_FORMULARIO)
                      const snapshotRespuestas = await rutaFormularioRespuestaExterno.get().toPromise();
                      //borrando subcolecciones
                      if(!snapshotRespuestas.empty){
                        snapshotRespuestas.forEach(resp => {
                          transaction.delete(resp.ref);
                        });
                      }
                      //borrando coleccion principal
                      transaction.delete(rutaFormularioExterno.ref);
                    }
                  }else{//despublicando encuesta ya que se modifico solo cabecera
                    if (!encuestaForm.empty) {
                      idFormularioPublicado = encuestaForm.docs[0].id;
                      const rutaFormularioExterno = this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL).doc(idFormularioPublicado);
                      transaction.update(rutaFormularioExterno.ref,{
                        'es_publicado':false
                      });
                    }
                  }
                              
                  //SUBIENDO IMAGENES
                  if (imagenesEliminar.length > 0) {
                    //subiendo archivo
                    const urls = await this.uploadService.onSaveFiles(files_upload, pathFileAPI)
                    //convirtiendo la lista de array
                    const resultsURls = Utils.ObjecToListToArray(urls);
                    let insertLogo:boolean = false;
                    let insertFondo:boolean = false;
                    let nImagenLogo!:any;
                    let nImagenFondo!:any;
                    if (cabeceraTemporal.encabezado.path_logo && cabeceraTemporal.encabezado.path_fondo) {
                      insertLogo = true;
                      insertFondo = true;
                      nImagenLogo = resultsURls[0];
                      nImagenFondo  = resultsURls[1];
                    }else{
                      if (cabeceraTemporal.encabezado.path_logo) {
                        insertLogo = true;
                        nImagenLogo = resultsURls[0];                      
                      }
                      if (cabeceraTemporal.encabezado.path_fondo) {
                        insertFondo = true;
                        nImagenFondo = resultsURls[0];
                      } 
                    }                  

                    //actualizando el documento
                    transaction.update(formularioRef.ref, {
                      'encabezado.titulo': cabeceraTemporal.encabezado.titulo,
                      'encabezado.es_vigente': cabeceraTemporal.encabezado.es_vigente,
                      'encabezado.horario_disponible':  Utils.SerializeJsonToDb(cabeceraTemporal.encabezado.horario_disponible),
                      'tipo_pregunta': Utils.SerializeJsonToDb(formulario.tipo_pregunta),
                      'fecha_modificacion': serverTimestamp(),
                      'es_publicado':false,
                      'usuario_modificacion': usuario,
                      ...(insertLogo && { 'encabezado.path_logo': nImagenLogo}),
                      ...(insertFondo && { 'encabezado.path_fondo': nImagenFondo})                   
                    });

                                
                    
                    this.transaccion.tx = true;
                    this.transaccion.data = formularioRef.ref.id;
                    return this.transaccion;
                              
                  }else{
                    const urls = await this.uploadService.onSaveFiles(files_upload, pathFileAPI);
                    const resultsURls = Utils.ObjecToListToArray(urls);
                    let insertLogo:boolean = false;
                    let insertFondo:boolean = false;
                    let nImagenLogo!:any;
                    let nImagenFondo!:any;
                    if (cabeceraTemporal.encabezado.path_logo && cabeceraTemporal.encabezado.path_fondo) {
                      insertLogo = true;
                      insertFondo = true;
                      nImagenLogo = resultsURls[0];
                      nImagenFondo  = resultsURls[1];
                    }else{
                      if (cabeceraTemporal.encabezado.path_logo) {
                        insertLogo = true;
                        nImagenLogo = resultsURls[0];                      
                      }
                      if (cabeceraTemporal.encabezado.path_fondo) {
                        insertFondo = true;
                        nImagenFondo = resultsURls[0];
                      } 
                    }                                    
                    transaction.update(formularioRef.ref, {
                      'encabezado.titulo': cabeceraTemporal.encabezado.titulo,
                      'encabezado.es_vigente': cabeceraTemporal.encabezado.es_vigente,
                      'encabezado.horario_disponible':  Utils.SerializeJsonToDb(cabeceraTemporal.encabezado.horario_disponible),
                      'tipo_pregunta': Utils.SerializeJsonToDb(formulario.tipo_pregunta),
                      'fecha_modificacion': serverTimestamp(),
                      'es_publicado':false,
                      'usuario_modificacion': usuario,
                      ...(insertLogo && { 'encabezado.path_logo': nImagenLogo }),
                      ...(insertFondo && { 'encabezado.path_fondo': nImagenFondo })
                    });

                    this.transaccion.tx = true;
                    this.transaccion.data = formularioRef.ref.id;
                    return this.transaccion;                   
                  }
                              
                
              }
              return this.transaccion;
          });  
          return transactionResult;
      } catch (error) {
          this.transaccion.tx = false;
          this.transaccion.data = error;
          return this.transaccion;
      }
  }

   getConfiguracionFormularioRuta(rutaParcial:string){
      return this.db.collection(colections.EXTERNO_ENCUESTA_DIGITAL, 
        (ref)=> ref.where(documentEncuesta.RUTA_PARCIAL,'==',rutaParcial)
        .where(documentEncuesta.ES_PUBLICADO,'==',true)
        .where(documentEncuesta.ES_BORRADO,'==',false)
      ).get().toPromise();    
   }
  

}
